import { Container } from "reactstrap";
import styles from './styles.module.scss';

export const Content = ({
  className,
  content,
  showGraphics,
  fullWidth,
}) => {

  return (
    <section className={`${styles.root} ${className} pb-5  ${showGraphics && styles.graphics} ${fullWidth ? styles.fullWidth : ''}`}>
      <Container fluid={fullWidth} className={fullWidth ? 'px-0' : ''}>
        <div className="mainContent" dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </section>
  );

}

export default Content;
